import { FC, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    InputAdornment,
    Typography
} from "@mui/material"
import PersonIcon from '@mui/icons-material/Person'
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload'

interface ForgetPasswordModalProps {
    open: boolean
    onClose: () => void
    onSubmit: (rut: string, rutCompany: string) => Promise<void>
}

export const ForgetPasswordModal: FC<ForgetPasswordModalProps> = ({
    open,
    onClose,
    onSubmit
}) => {
    const [rut, setRut] = useState("")
    const [rutCompany, setRutCompany] = useState<string>('')
    const [error, setError] = useState("")
    const [loading, setLoading] = useState<boolean>(false)

    const handleSend = async () => {
        if (rut.trim() === "") {
            setError("Por favor ingresa su RUT de usuario")

            return
        }
        setLoading(true)
        await onSubmit(rut, rutCompany)
        onClose()
        setLoading(false)
    }

    const handleClose = () => {
        setError("")
        onClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>Recuperar contraseña</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="textSecondary" mb={2}>
                    Se enviará un correo con las credenciales al correo asociado del usuario.
                </Typography>
                <TextField
                    id="rut"
                    name="rut"
                    fullWidth
                    variant="outlined"
                    value={rut}
                    onChange={(e) => {
                        const { value } = e.target

                        let newValue = value

                        let cleanRut = value.replace(/[^0-9kK]/g, '').toUpperCase()

                        let rutBody = cleanRut.slice(0, -1)
                        let dv = cleanRut.slice(-1)

                        rutBody = rutBody.slice(0, 8)
                        dv = dv.replace(/[^0-9K]/g, '')

                        let formatted = ''
                        if (rutBody.length > 0) {
                            let reversed = rutBody.split('').reverse()
                            let withDots: string[] = []

                            for (let i = 0; i < reversed.length; i++) {
                                withDots.push(reversed[i])
                                if ((i + 1) % 3 === 0 && i + 1 < reversed.length) {
                                    withDots.push('.')
                                }
                            }

                            formatted = withDots.reverse().join('')
                        }

                        if (dv) {
                            formatted += `-${dv}`
                        }

                        newValue = formatted

                        setRut(newValue)
                    }}
                    placeholder="RUT de usuario"
                    label="RUT de usuario"
                    size="small"
                    type="text"
                    InputProps={{
                        inputProps: {
                            maxLength: 12
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                <PersonIcon sx={{ color: '#29333B' }} />
                            </InputAdornment>
                        )
                    }}
                    error={!!error}
                    helperText={error}
                />
                <TextField
                    id="rutCompany"
                    name="rutCompany"
                    fullWidth
                    variant="outlined"
                    value={rutCompany}
                    onChange={(e) => {
                        const { value } = e.target

                        let newValue = value

                        let cleanRut = value.replace(/[^0-9kK]/g, '').toUpperCase()

                        let rutBody = cleanRut.slice(0, -1)
                        let dv = cleanRut.slice(-1)

                        rutBody = rutBody.slice(0, 8)
                        dv = dv.replace(/[^0-9K]/g, '')

                        let formatted = ''
                        if (rutBody.length > 0) {
                            let reversed = rutBody.split('').reverse()
                            let withDots: string[] = []

                            for (let i = 0; i < reversed.length; i++) {
                                withDots.push(reversed[i])
                                if ((i + 1) % 3 === 0 && i + 1 < reversed.length) {
                                    withDots.push('.')
                                }
                            }

                            formatted = withDots.reverse().join('')
                        }

                        if (dv) {
                            formatted += `-${dv}`
                        }

                        newValue = formatted

                        setRutCompany(newValue)
                    }}
                    placeholder="RUT de empresa"
                    label="RUT de empresa"
                    size="small"
                    type="text"
                    InputProps={{
                        inputProps: {
                            maxLength: 12
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                <AssuredWorkloadIcon sx={{ color: '#29333B' }} />
                            </InputAdornment>
                        )
                    }}
                    error={!!error}
                    helperText={error}
                    sx={{ mt: 2 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={handleSend} variant="contained" color="primary" disabled={loading}>
                    Enviar
                </Button>
            </DialogActions>
        </Dialog>
    )
}